/**
 * Tenant TopBar configuration data — extracted so tests can import these
 * pure data structures without pulling in the full App / UI library tree.
 */
import {
  GitMerge,
  SettingsIcon as Settings2Icon,
  CreditCard,
  Users,
  KeyRound,
  Radio,
  Globe,
  Activity,
  FileText,
  Link,
  type MenuItem,
} from '@ensafely/checker-ui'

/** Top-level navigation buttons rendered in the tenant TopBar primary cluster. */
export const CLOUD_NAV_ITEMS = [
  { path: '/connections', label: 'Connections', icon: <Link className="h-4 w-4 mr-1" /> },
]

/** Items appended to the user dropdown menu in the tenant TopBar. */
export const CLOUD_USER_MENU_ITEMS: MenuItem[] = [
  { key: 'account', label: 'Account', icon: <Settings2Icon className="mr-2 h-4 w-4" />, href: '/account' },
  { key: 'billing', label: 'Billing', icon: <CreditCard className="mr-2 h-4 w-4" />, href: '/account/billing' },
  { key: 'team', label: 'Team', icon: <Users className="mr-2 h-4 w-4" />, href: '/account/team' },
  { key: 'api-keys', label: 'API Keys', icon: <KeyRound className="mr-2 h-4 w-4" />, href: '/account/api-keys' },
  { key: 'edge-probes', label: 'Edge Probes', icon: <Radio className="mr-2 h-4 w-4" />, href: '/account/edge-probes' },
  { key: 'regions', label: 'Regions', icon: <Globe className="mr-2 h-4 w-4" />, href: '/account/platform-regions' },
  { key: 'status-page', label: 'Status Page', icon: <Activity className="mr-2 h-4 w-4" />, href: '/account/status-page' },
  { key: 'escalation-policies', label: 'Escalation Policies', icon: <GitMerge className="mr-2 h-4 w-4" />, href: '/escalation-policies' },
  { key: 'reports', label: 'Reports', icon: <FileText className="mr-2 h-4 w-4" />, href: '/reports' },
]
